import React from "react";
import {Button, KIND, SHAPE, SIZE as BTN_SIZE} from "baseui/button";
import {MdFormatListBulletedAdd} from "react-icons/md";

const AddQues = ({toggleAddQuestion}) => {

    return (
        <>
            <Button
                className="add-question-button"
                shape={SHAPE.circle}
                kind={KIND.secondary}
                size={BTN_SIZE.compact}
                overrides={{
                    BaseButton: {
                        style: {
                            position: "fixed",
                            bottom: "75px",
                            right: "24px",
                            width: "40px",
                            height: "40px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }
                    }
                }}
                onClick={() => toggleAddQuestion()}
            >
                <MdFormatListBulletedAdd size={18}/>
            </Button>
        </>
    );
};

export default AddQues;